var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M12.633 2H5.727c-.95 0-1.718.808-1.718 1.794L4 18.15c0 .987.768 1.794 1.718 1.794H12.5a5.23 5.23 0 0 1-1.062-3.166c0-2.915 2.378-5.278 5.312-5.278q.547 0 1.063.106V7.383zm-.863 6.28V3.347l4.748 4.935z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M15.597 12.556v4.717l-1.514-1.25-1.583 1.465L16.75 21 21 17.488l-1.583-1.466-1.514 1.251v-4.717z"
  })));
};
export default SvgDownload;